import { action, payload } from 'ts-action'

const prefix = 'filter'

export const setInitialFilter = action(`${prefix}/SET-INITIAL`, payload<{ filter: string; value: string[] }>())
export const addActiveFilter = action(`${prefix}/ACTIVE--ADD`, payload<{ filter: string; value: string }>())
export const removeActiveFilter = action(`${prefix}/ACTIVE--REMOVE`, payload<{ filter: string; value: string }>())
